import { h, Component } from 'preact';
import SearchInput from '../search-input';
import { withText } from 'preact-i18n';
import { withConfig } from '../../config';
import { trackingProvider, DIMENSION } from '@cube/track';
import logoImage from '../../assets/enhanced_by_google.png';

@withConfig([
	'search.google.searchURL',
	'search.google.queryParameter',
	'search.google.hiddenParameters'
])
@withText({
	placeHolderText: 'searchTheWeb'
})
@trackingProvider({
	[DIMENSION.componentpath]: 'Google'
})
export default class Google extends Component {

	static defaultProps = {
		providerInputSuffix: 'input_provider_google',
		logoImage
	};

	render( props ) {
		return <SearchInput {...props} />;
	}
}
